var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4774 6.69867C8.14501 7.02968 8.8919 7.4 9.863 7.4C11.7123 7.4 14.589 5.2 15 3C14.4521 3.2 13.1096 3.6 12.1233 3.6C11.137 3.6 10.0685 2.8 9.65752 2.4C9.24656 1.6 7.8493 0 5.54792 0C3.24655 0 2.39723 0.933333 2.26024 1.4V7.8C3.52498 6.71801 4.27584 6.37258 5.7534 6.2C6.33471 6.1321 6.87364 6.39931 7.4774 6.69867ZM0.92466 0.6C0.413984 0.6 0 1.00294 0 1.5V13L1.84932 14V1.5C1.84932 1.00294 1.43534 0.6 0.92466 0.6Z",
    fill: "#596873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleFlagIcon);
export default __webpack_public_path__ + "static/media/simple-flag-icon.b050d744e8fb06582e651e43dcf7b141.svg";
export { ForwardRef as ReactComponent };